import { createRouter, createWebHashHistory } from 'vue-router';
import Home from '../views/Home.vue';
import SignUpSteps from '../views/auth/SignUpSteps.vue';
import ProfilePage from '../views/auth/ProfilePage.vue';
import DiscussionBoards from '../views/boards/DiscussionBoards.vue';
import LeagueDashboard from '../views/league/LeagueDashboard.vue';
import TeamDashboard from '../views/team/TeamDashboard.vue'
import NotificationView from '@/components/notifications/NotificationView.vue'
import TeamPage from '../views/team/TeamPage.vue'
import NotFound from '../views/NotFound.vue';
import store from '../store/index.js';

const router = createRouter({
	history: createWebHashHistory(process.env.BASE_URL),
	routes: [
		{
			path: '/',
			component: Home,
		},
		{
			path: '/signup',
			name: 'SignUp',
			component: SignUpSteps,
		},
		{
			path: '/profile',
			name: 'Profile',
			component: ProfilePage,
			meta: { requiresAuth: true },
		},
		{
			path: '/discussions',
			name: 'Discussions',
			component: DiscussionBoards,
			meta: { requiresAuth: true },
		},
		{
			path: '/manage-league',
			name: 'LeagueDashboard',
			component: LeagueDashboard,
			meta: { requiresAuth: true },
		},
		{
			path: '/manage-team',
			name: 'TeamDashboard',
			component: TeamDashboard,
			meta: { requiresAuth: true },
		},
		{
			path: '/team-page',
			name: 'TeamPage',
			component: TeamPage,
			meta: { requiresAuth: true },
		},
		{
			path: '/notifications',
			name: 'Notifications',
			component: NotificationView,
			meta: { requiresAuth: true },
		},
		{ path: '/:notFound(.*)', component: NotFound },
		//   {
		//     path: '/about',
		//     name: 'About',
		//     // route level code-splitting
		//     // this generates a separate chunk (about.[hash].js) for this route
		//     // which is lazy-loaded when the route is visited.
		//     component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
		//   }
	],
});

router.beforeEach(function (to, _, next) {
	if (to.meta.requiresAuth && !store.getters.isAuthenticated) {
		next('/');
	} else if (to.meta.requiresUnauth && store.getters.isAuthenticated) {
		next('/discussions');
	} else {
		next();
	}
});
export default router;
